const userManager = {
  path: '/userManager',
  component: resolve => require(['../../../../pages/modules/userManager'], resolve),
  meta: {
    requireAuth: true
  }
}

export default userManager